import {Injectable} from "@angular/core";
import {ParameterRule} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {FactorBaseService} from "./factor-base-service";

@Injectable()
export class RiskService extends FactorBaseService{
  static readonly RISK = "risk";
  static readonly RISKFACTORS = "riskfactors";

  public getDisplayName(parameterRule: ParameterRule) : string {
    //create a dictionary of Rules where the attribute type is the key (e.g., gene, origin)
    this.parameterRulesMap = {};
    let parameterRules = parameterRule.rules;
    for (let rule of parameterRules) {
      this.parameterRulesMap[rule.field.toLowerCase()] = rule;
    }

    //get risk type
    let parameter: string = parameterRule.parameter.toLowerCase();
    let riskType: string = "";
    switch (parameter.toLowerCase()) {
      case "risk": {
        riskType = this.theRisk();
        break;
      }
    }
    return riskType;
  }

  private theRisk(): string {
    /*
    Risk
    {Risk} ‘Risk’
    ‘Risk Factors’ {Risk Factors}
     */
    var results: string[] = new Array();
    this.risk(results);
    this.riskFactors(results);
    let delimitedString = results.join(RiskService.SPACE);
    return delimitedString;
  }

  private risk(results: string[]) {
    let rule = this.parameterRulesMap[RiskService.RISK];
    if (rule) {
      let displayValue: string = rule.value.display + " Risk";
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private riskFactors(results: string[]) {
    let rule = this.parameterRulesMap[RiskService.RISKFACTORS];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results, "Risk Factors: ");
    }
  }

}
